<div class="info-drag-table-info">
  <div class="info-drag-table-row-info" *ngFor="let item of filteredInfo; trackBy: trackByKey">
    <div class="info-drag-table-cell-info">{{item?.key | transloco}}</div>

    <ng-container [ngSwitch]="item?.key">

      <ng-container *ngSwitchCase="'categories'">
        <div class="info-drag-table-cell-info info-drag-table-cell-link">
          <a class="interactive" (click)="eventClearSearchState()" [routerLink]="toLinkHrefCustomCatalog(el)"
             *ngFor="let el of item?.value, let id = index" class="link-to-search">
<!--            <i style="color: #292929bf; display: block; height: 5px;" *ngIf="id > 0" [innerHTML]="spacer"></i>-->
            {{el.name}}
          </a>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'ath'">
        <div class="info-drag-table-cell-info">
                  <span (click)="eventLinkATHToSearch(item)" class="link-to-search-ath interactive">{{item.value}}
                  </span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'priceRange'">
        <div class="info-drag-table-cell-info">
          {{item.value | moneyFormat}}
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'avgPrice'">
        <div class="info-drag-table-cell-info">
          {{item.value | moneyFormat}}
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <div class="info-drag-table-cell-info">
          {{item.value}}
        </div>
      </ng-container>

    </ng-container>

  </div>
</div>
